/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { CustomersModule } from '@app/customers/customers.module';
import { AppointmentsModule } from '@appointments/appointments.module';
import { RemindersModule } from '@reminders/reminders.module';
import { SharedModule } from '@shared/shared.module';
import { AppointmentClassAsyncPipe } from '@tours/pipes/appointment-class-async.pipe';
import { AvailableActionsPipe } from '@tours/pipes/available-actions.pipe';
import { UserNamePipe } from '@tours/pipes/user-name.pipe';
import { FormBasicInformationComponent } from '@tours/tour-detail/form-basic-information/form-basic-information.component';
import { TourDetailComponent } from '@tours/tour-detail/tour-detail.component';
import { ConfirmationOverlayComponent } from '@tours/tours/tour-list/tour-item-menu/confirmation-overlay/confirmation-overlay.component';
import { TourListComponent } from '@tours/tours/tour-list/tour-list.component';
import { UserModule } from '@users/user.module';
import { AngularSplitModule } from 'angular-split';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxBarcode6 } from 'ngx-barcode6';
import { DriverNamesPipe } from './pipes/driver-names.pipe';
import { NumericStatePipe } from './pipes/numeric-state.pipe';
import { FormBaseDataComponent } from './tour-detail/form-base-data/form-base-data.component';
import { FormDocumentsComponent } from './tour-detail/form-documents/form-documents.component';
import { FormDriversComponent } from './tour-detail/form-drivers/form-drivers.component';
import { BarcodeComponent } from './tour-notes-list/barcode/barcode.component';
import { TourNotesListComponent } from './tour-notes-list/tour-notes-list.component';
import { AbsencesInfoComponent } from './tours/absences-info/absences-info.component';
import { CalendarComponent } from './tours/calendar/calendar.component';
import { TourItemDriversComponent } from './tours/tour-list/tour-item-drivers/tour-item-drivers.component';
import { TourItemMenuComponent } from './tours/tour-list/tour-item-menu/tour-item-menu.component';
import { TourItemProgressComponent } from './tours/tour-list/tour-item-progress/tour-item-progress.component';
import { TourItemVaoComponent } from './tours/tour-list/tour-item-vao/tour-item-vao.component';
import { ToursComponent } from './tours/tours.component';

@NgModule({
    declarations: [
        ToursComponent,
        TourDetailComponent,
        TourListComponent,
        FormBasicInformationComponent,
        FormBaseDataComponent,
        FormDriversComponent,
        TourItemProgressComponent,
        NumericStatePipe,
        TourItemMenuComponent,
        AppointmentClassAsyncPipe,
        DriverNamesPipe,
        UserNamePipe,
        TourItemDriversComponent,
        AbsencesInfoComponent,
        CalendarComponent,
        FormDocumentsComponent,
        TourNotesListComponent,
        TourItemVaoComponent,
        AvailableActionsPipe,
        BarcodeComponent,
        ConfirmationOverlayComponent,
    ],
    imports: [
        CustomersModule,
        FileUploadModule,
        SharedModule,
        AppointmentsModule,
        AngularSplitModule,
        RemindersModule,
        UserModule,
        NgxBarcode6
    ],
    exports: [
        ToursComponent,
        TourDetailComponent,
        TourListComponent
    ],
    providers: [
        NumericStatePipe,
    ]
})
export class ToursModule { }
